import { Injectable } from '@angular/core';
import { FormGroup, FormArray, AbstractControl } from '@angular/forms';

@Injectable()
export class FormToolsService {
  showFormErrors(mainForm: FormGroup): void {
    let parseForm = (form) => {
      for (let i in form.controls) {
        if (form.controls[i] instanceof FormArray) {
          let formField: FormArray = <FormArray>form.controls[i];
          
          formField.controls.forEach((control) => {
            parseForm(control);
          });
        } else if (form.controls[i] instanceof FormGroup) {
          parseForm(form.controls[i]);
        } else {
          form.controls[i].markAsTouched();
        }
      }
    };

    parseForm(mainForm);
  }

  isValidField(form, field: string, error: string = ''): boolean {   
    let formField: AbstractControl;

    if (field.indexOf(':') == -1) {
      formField = form.get(field);
    } else {
      let parts = field.split(':');
      formField = form.get(parts[0]).get(parts[1]);
    }

    if ((formField.touched === false) && (formField.pristine === true)) {
      return true;
    }

    return (error == '') ? formField.valid : !formField.hasError(error);
  }

  reorderFormArray(formArray: FormArray, positionStart: number, positionEnd: number): FormArray {
    if (positionStart != positionEnd) {
      let controls = formArray.controls.slice();
      let itemSelected = formArray.controls[positionStart];
      formArray.controls = [];

      controls.forEach((control, i) => {
        if (positionStart > positionEnd) {
          if ((i > positionStart) || (i < positionEnd)) {
            formArray.controls[i] = control;
          } else if (i == positionEnd) {
            formArray.controls[i] = itemSelected;
            formArray.controls[i + 1] = control;
          } else if (i != positionStart) {
            formArray.controls[i + 1] = control;
          }
        } else {
          if ((i < positionStart) || (i > positionEnd)) {
            formArray.controls[i] = control;
          } else if (i == positionEnd) {
            formArray.controls[i] = itemSelected;
            formArray.controls[i - 1] = control;
          } else if (i != positionStart) {
            formArray.controls[i - 1] = control;
          }
        }
      });

      formArray = this.updatePositionsFormArray(formArray);    
    }

    return formArray; 
  }

  updatePositionsFormArray(formArray: FormArray): FormArray {
    formArray.controls.map((x, y) => x.patchValue({ position: y + 1 })); 

    return formArray;
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/services/form-tools.service.ts